module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section small-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-group smart-accordion-default",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title box-header"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": '#stats-hoy'
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('h2', [_c('b', [_vm._v("PEDIDOS PARA EL DIA DE HOY " + _vm._s(_vm.fechaHoy))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": 'stats-hoy'
    }
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "box-style line-top smart-form"
  }, [_c('div', {
    staticClass: "box-header-lg row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("EMPRESA")]), _vm._v(" "), _c('select', {
    ref: "slEmpresaHoy",
    staticClass: "form-control select2 filter-select2",
    staticStyle: {
      "z-index": "1000",
      "width": "100%!important",
      "max-width": "100%"
    },
    attrs: {
      "multiple": "",
      "data-select2-container": "big-text"
    }
  }, _vm._l((_vm.empresas), function(empresa) {
    return _c('option', {
      key: empresa._id,
      domProps: {
        "value": empresa._id
      }
    }, [_vm._v(_vm._s(empresa.empresa.razonSocial) + " - " + _vm._s(empresa.denominacion))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.entregasHoyLoading) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  })]) : _vm._e(), _vm._v(" "), (!_vm.entregasHoyLoading && _vm.pedidosHoy == 0 && _vm.entregasHoyFiltradas.length == 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('h2', [_vm._v("No hay pedidos en el día de la fecha")])]) : _vm._e(), _vm._v(" "), (_vm.pedidosHoy > 0) ? _c('div', {
    staticClass: "text-center col-xs-3 col-sm-3 col-md-3 col-lg-3",
    staticStyle: {
      "padding-left": "5px",
      "padding-right": "5px"
    }
  }, [_c('label', [_vm._v("TOTALES")]), _vm._v(" "), _c('div', {
    staticClass: "well bg-primary"
  }, [_c('div', {
    staticClass: "horizontal statistic"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "horizontal statistic"
  }, [_c('div', {
    staticClass: "value ranking"
  }, [_vm._v(_vm._s(_vm.pedidosHoy))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Pedidos")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "horizontal statistic small"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("formatearMoneda")(_vm.pedidosHoyTotal)))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  })])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.entregasHoyFiltradas), function(entrSuc, idx) {
    return [_c('div', {
      key: entrSuc.sucursal._id,
      staticClass: "text-center col-xs-3 col-sm-3 col-md-3 col-lg-3",
      staticStyle: {
        "padding-left": "5px",
        "padding-right": "5px"
      }
    }, [_c('div', {
      staticClass: "well"
    }, [_c('label', [_vm._v(_vm._s(entrSuc.sucursal.empresa.razonSocial) + " - " + _vm._s(entrSuc.sucursal.denominacion))]), _vm._v(" "), _c('div', {
      staticClass: "horizontal statistic"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "horizontal statistic"
    }, [_c('div', {
      staticClass: "value ranking",
      class: ['p' + idx.toString()]
    }, [_vm._v(_vm._s(entrSuc.size))]), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v("Pedidos")])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "horizontal statistic small"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm._f("formatearMoneda")(entrSuc.amount)))]), _vm._v(" "), _c('div', {
      staticClass: "label"
    })])])])])])]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title box-header"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": '#stats-pedidos'
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": 'stats-pedidos'
    }
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "box-style line-top smart-form"
  }, [_c('div', {
    staticClass: "box-header-lg row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("DESDE")]), _vm._v(" "), _c('date-picker', {
    ref: "pickerDesde",
    model: {
      value: (_vm.fechaDesde),
      callback: function($$v) {
        _vm.fechaDesde = $$v
      },
      expression: "fechaDesde"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("HASTA")]), _vm._v(" "), _c('date-picker', {
    ref: "pickerHasta",
    model: {
      value: (_vm.fechaHasta),
      callback: function($$v) {
        _vm.fechaHasta = $$v
      },
      expression: "fechaHasta"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("EMPRESA")]), _vm._v(" "), _c('select', {
    ref: "slEmpresa",
    staticClass: "form-control select2 filter-select2",
    staticStyle: {
      "z-index": "1000",
      "width": "100%!important",
      "max-width": "100%"
    },
    attrs: {
      "multiple": "",
      "data-select2-container": "big-text"
    }
  }, _vm._l((_vm.empresas), function(empresa) {
    return _c('option', {
      key: empresa._id,
      domProps: {
        "value": empresa._id
      }
    }, [_vm._v(_vm._s(empresa.empresa.razonSocial) + " - " + _vm._s(empresa.denominacion))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "padding-top": "22px"
    }
  }, [_c('a', {
    staticClass: "btn btn-success btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.filtrarEntregas()
      }
    }
  }, [_vm._v("Aplicar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.entregasLoading) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  })]) : _vm._e(), _vm._v(" "), (!_vm.entregasLoading && _vm.pedidosFiltrados == 0 && _vm.entregasFechasFiltradas.length == 0 && _vm.fechaDesde && _vm.fechaHasta) ? _c('div', {
    staticClass: "text-center"
  }, [_c('h2', [_vm._v("No hay pedidos en el rango de fechas seleccionado")])]) : _vm._e(), _vm._v(" "), (!_vm.entregasLoading && (!_vm.fechaDesde || !_vm.fechaHasta)) ? _c('div', {
    staticClass: "text-center"
  }, [_c('h2', [_vm._v("Seleccione el rango de fechas y haga click en \"Aplicar\"")])]) : _vm._e(), _vm._v(" "), (_vm.pedidosFiltrados > 0) ? _c('div', {
    staticClass: "text-center col-xs-3 col-sm-3 col-md-3 col-lg-3",
    staticStyle: {
      "padding-left": "5px",
      "padding-right": "5px"
    }
  }, [_c('label', [_vm._v("TOTALES")]), _vm._v(" "), _c('div', {
    staticClass: "well bg-primary"
  }, [_c('div', {
    staticClass: "horizontal statistic"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "horizontal statistic"
  }, [_c('div', {
    staticClass: "value ranking"
  }, [_vm._v(_vm._s(_vm.pedidosFiltrados))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Pedidos")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "horizontal statistic small"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("formatearMoneda")(_vm.pedidosFiltradosTotal)))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  })])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.entregasFechasFiltradas), function(entrSuc, idx) {
    return [_c('div', {
      key: entrSuc.sucursal._id,
      staticClass: "text-center col-xs-3 col-sm-3 col-md-3 col-lg-3",
      staticStyle: {
        "padding-left": "5px",
        "padding-right": "5px",
        "min-height": "300px"
      }
    }, [_c('div', {
      staticClass: "well"
    }, [_c('label', [_vm._v(_vm._s(entrSuc.sucursal.empresa.razonSocial) + " - " + _vm._s(entrSuc.sucursal.denominacion))]), _vm._v(" "), _c('div', {
      staticClass: "horizontal statistic"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "horizontal statistic"
    }, [_c('div', {
      staticClass: "value ranking",
      class: ['p' + idx.toString()]
    }, [_vm._v(_vm._s(entrSuc.size))]), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v("Pedidos")])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "horizontal statistic small"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm._f("formatearMoneda")(entrSuc.amount)))]), _vm._v(" "), _c('div', {
      staticClass: "label"
    })])])])])])]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title box-header"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": '#stats-ranking'
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": 'stats-ranking'
    }
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "box-header-lg row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("DESDE")]), _vm._v(" "), _c('date-picker', {
    ref: "pickerDesde",
    attrs: {
      "max-date": new Date()
    },
    model: {
      value: (_vm.fechaDesdeRanking),
      callback: function($$v) {
        _vm.fechaDesdeRanking = $$v
      },
      expression: "fechaDesdeRanking"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("HASTA")]), _vm._v(" "), _c('date-picker', {
    ref: "pickerHasta",
    attrs: {
      "max-date": new Date()
    },
    model: {
      value: (_vm.fechaHastaRanking),
      callback: function($$v) {
        _vm.fechaHastaRanking = $$v
      },
      expression: "fechaHastaRanking"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("PROVEEDOR")]), _vm._v(" "), _c('select', {
    ref: "slProveedor",
    staticClass: "form-control select2 filter-select2",
    staticStyle: {
      "z-index": "1000",
      "width": "100%!important",
      "max-width": "100%"
    },
    attrs: {
      "multiple": "",
      "data-select2-container": "big-text"
    }
  }, _vm._l((_vm.restaurantes), function(resto) {
    return _c('option', {
      key: resto._id,
      domProps: {
        "value": resto._id
      }
    }, [_vm._v(_vm._s(resto.razonSocial))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("EMPRESA")]), _vm._v(" "), _c('select', {
    ref: "slEmpresaRanking",
    staticClass: "form-control select2 filter-select2",
    staticStyle: {
      "z-index": "1000",
      "width": "100%!important",
      "max-width": "100%"
    },
    attrs: {
      "multiple": "",
      "data-select2-container": "big-text"
    }
  }, _vm._l((_vm.empresas), function(empresa) {
    return _c('option', {
      key: empresa._id,
      domProps: {
        "value": empresa._id
      }
    }, [_vm._v(_vm._s(empresa.empresa.razonSocial) + " - " + _vm._s(empresa.denominacion))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "padding-top": "22px"
    }
  }, [_c('a', {
    staticClass: "btn btn-success btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.filtrarRanking()
      }
    }
  }, [_vm._v("Aplicar")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.rankingLoading) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._l((_vm.ranking), function(cat) {
    return (!_vm.rankingLoading) ? [_c('div', {
      key: cat.categoria,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('h3', [_vm._v(_vm._s(cat.categoria))]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(3, true)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._l((cat.ranking), function(rank, idx) {
      return [_c('div', {
        key: rank._id,
        staticClass: "col-md-12 stats",
        class: {
          'bg-grey': idx % 2 != 0
        }
      }, [_c('div', {
        staticClass: "col-md-3 horizontal text-center statistic"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "horizontal statistic xmini"
      }, [_c('div', {
        staticClass: "value"
      }, [_vm._v(_vm._s(rank.plato.nombre) + " (" + _vm._s(rank.proveedor.razonSocial) + ")")])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-6 text-center"
      }, [_c('div', {
        staticClass: "horizontal statistic"
      }, [_c('div', {
        staticClass: "horizontal statistic small text-center"
      }, [_c('div', {
        staticClass: "value ranking",
        class: ['p' + idx.toString()]
      }, [_vm._v(_vm._s(rank.size))]), _vm._v(" "), _c('div', {
        staticClass: "label"
      }, [_vm._v("Pedidos")])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-3 well",
        staticStyle: {
          "padding-top": "10px",
          "margin-top": "10px"
        }
      }, [_vm._l((rank.sucs), function(cliente) {
        return [_c('div', {
          key: cliente._id,
          staticClass: "row"
        }, [_c('div', {
          staticClass: "horizontal statistic xmini"
        }, [_c('div', {
          staticClass: "value"
        }, [_vm._v(_vm._s(cliente.size))]), _vm._v(" "), _c('div', {
          staticClass: "label"
        }, [_vm._v(_vm._s(cliente.sucursal.empresa.razonSocial) + " - " + _vm._s(cliente.sucursal.denominacion))])])])]
      })], 2)])]
    })], 2)] : _vm._e()
  })], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "center-block"
  }, [_c('h2', [_vm._v("Estadísticas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('b', [_vm._v("PEDIDOS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('b', [_vm._v("RANKING DE PLATOS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 stats"
  }, [_c('div', {
    staticClass: "col-md-3 text-center"
  }, [_c('label', [_vm._v("Plato")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('label', [_vm._v("Cantidad")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Pedidos por Empresa")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd27ca7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats/Stats.vue
// module id = 1108
// module chunks = 5